import React from 'react';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { Icons } from '../../../../../../../Themes';
import EmptyState from '../../../../../../DesignSystem/EmptyState';
import CustomIcon from '../../../../../../DesignSystem/CustomIcon';

function EmptyDefault() {
  const title = (
    <Typography variant="body1">
      <FormattedMessage id="POSTS.CONSULTATIONS.FEED_TITLE.IDEAS_COUNT" values={{ itemCount: 0 }} />
    </Typography>
  );

  return (
    <EmptyState
      content={title}
      icon={<CustomIcon src={Icons.misc.bulb} color="primary" size={30} />}
      action={null}
    />
  );
}

export default EmptyDefault;
